import styles from "./PersonalInformation.module.scss";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Form } from "antd";
import FormItemInput from "../../../components/ui/FormItemInput/FormItemInput";
import FormItemSelect from "../../../components/ui/FormItemSelect/FormItemSelect";
import FormItemDatePicker from "../../../components/ui/FormItemDatePicker/FormItemDatePicker";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import useAppSelector from "../../../hooks/useAppSelector";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { Link } from "react-router-dom";
import { IUpdateUserModel } from "../../../models/User";
import { updateProfile } from "../../../store/userProfile/userProfileSlice";
import { openSuccessMessage } from "../../../store/message/messageSlice";
import { useUserMutations } from "../../../api/mutations";
import { handleError } from "../../../helper/errorHandler";

const PersonalInformation = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { updateUser } = useUserMutations();
  const { user } = useAppSelector((state) => state.userProfileSlice);

  const onFinish = async (values: IUpdateUserModel) => {
    if (!user) return;

    const model: IUpdateUserModel = {
      id: user?.id,
      firstname: values.firstname.trim(),
      lastname: values.lastname.trim(),
      username: values.username ? values.username.trim() : null,
      dateOfBirth: values.dateOfBirth,
      gender: values.gender,
    };

    updateUser(model, {
      onSuccess: (response) => {
        dispatch(openSuccessMessage(t("UserUpdatedSuccessfully")));
        dispatch(updateProfile(response));
      },
      onError: (e) => handleError(e, dispatch, t),
    });
  };

  const genderItems = [
    { id: "male", label: t("Male") },
    { id: "female", label: t("Female") },
  ];

  const initialValues = user
    ? {
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        username: user.username,
        gender: user.gender,
        dateOfBirth: user.dateOfBirth ? dayjs(user.dateOfBirth) : null,
      }
    : undefined;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t("PersonalInformation")}</h2>
      <Form
        className={styles.form}
        name="personal-information"
        initialValues={initialValues}
        onFinish={onFinish}
        autoComplete="off"
        layout={"vertical"}
      >
        <div className={styles.wrapper}>
          <div className={styles.item}>
            <FormItemInput
              isSettingInput={true}
              name={"firstname"}
              label={t("FirstName")}
              rules={{ required: true }}
            />
          </div>
          <div className={styles.item}>
            <FormItemInput
              isSettingInput={true}
              name={"lastname"}
              label={t("LastName")}
              rules={{ required: true }}
            />
          </div>
          <div className={styles.item}>
            <FormItemInput
              isSettingInput={true}
              disabled={true}
              name={"email"}
              label={t("EmailAddress")}
              rules={{ required: true }}
            />
          </div>
          <div className={styles.item}>
            <FormItemInput
              isSettingInput={true}
              name={"username"}
              label={t("Username")}
              rules={{ required: false }}
            />
          </div>
          <div className={styles.item}>
            <FormItemSelect
              name={"gender"}
              label={t("Gender")}
              rules={{ required: false }}
              items={genderItems}
            />
          </div>
          <div className={styles.item}>
            <FormItemDatePicker
              clearIcon={false}
              dateFormat={"DD/MM/YYYY"}
              name={"dateOfBirth"}
              label={t("DateOfBirth")}
              rules={{ required: false }}
            />
          </div>
        </div>
        <div className={styles.btnWrapper}>
          <CustomButton text={t("SaveChanges")} type={"submit"} typeStyle={"fill"} />
        </div>
      </Form>
      <Link className={styles.link} to={"change-password"}>
        {t("ChangePassword")}
      </Link>
    </div>
  );
};

export default PersonalInformation;
